<script setup lang="ts">
// /apps/<appId>?af--… : a link out of an Omni app (e.g. "Open ad") opens the org's page for that app,
// with the link's filters; the dashboards may still be loading right after login
import { watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useDashboards } from '@/stores/dashboards'

const route = useRoute()
const router = useRouter()
const dashboards = useDashboards()

watchEffect(() => {
  const all = dashboards.analysis.flatMap((a) => a.dashboards)
  if (!all.length) return
  const target = all.find((d) => d.dashboard_url === `/apps/${route.params.appId}`)
  router.replace(
    target
      ? { name: 'dashboard', params: { id: target.id }, query: route.query }
      : { name: 'home' },
  )
})
</script>

<template>
  <div />
</template>
